import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ dealership }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const voucherValue = dealership?.voucherValue || 150;
  const voucherCurrency = dealership?.voucherCurrency || 'Euro';
  const partnerName = dealership?.name || 'Ihrem Partner';

  const premium2026 = Number(dealership?.premium2026 ?? dealership?.voucherValue ?? 150);
  const premium2027 = Number(dealership?.premium2027 ?? 0);
  const totalPremium = premium2026 + premium2027;
  const has2027 = premium2027 > 0;

  const faqs = [
    {
      question: 'Was ist die THG-Quote und warum erhalte ich einen Gutschein?',
      answer: `Die Treibhausgasminderungsquote (THG-Quote) ist ein gesetzliches Instrument zur Förderung der Elektromobilität in Deutschland. Jeder Halter eines Elektrofahrzeugs hat Anspruch auf ein jährliches CO₂-Zertifikat. Da dieses Zertifikat nur über zertifizierte Dienstleister gehandelt werden kann, übernehmen wir das für Sie – und Sie erhalten dafür einen Gutschein, einlösbar bei ${partnerName}.`
    },
    {
      question: `Warum kann ich bis zu ${totalPremium} ${voucherCurrency} Gutschein erhalten?`,
      answer: has2027
        ? `Wenn Sie Ihre THG-Quote für 2026 und 2027 gleichzeitig registrieren, erhalten Sie für jedes Jahr einen Gutschein – das ergibt zusammen bis zu ${totalPremium} ${voucherCurrency}, einlösbar bei ${partnerName}. Wer nur für 2026 registriert, erhält entsprechend ${premium2026} ${voucherCurrency}.`
        : `Wenn Sie Ihre THG-Quote für 2026 registrieren, erhalten Sie ${premium2026} ${voucherCurrency} Gutschein, einlösbar bei ${partnerName}.`
    },
    {
      question: 'Was muss ich dafür tun?',
      answer: 'Nur das Formular ausfüllen, Fahrzeugschein hochladen und die 2027-Option aktivieren. Alles Weitere übernehmen wir.'
    },
    {
      question: 'Kann ich den Gutschein bar auszahlen lassen?',
      answer: `Nein, der Gutschein ist ausschließlich für Serviceleistungen bei ${partnerName} bestimmt – nicht als Barauszahlung.`
    },
    {
      question: 'Wie lange dauert es, bis ich den Gutschein bekomme?',
      answer: 'Die Prüfung durch das Umweltbundesamt dauert in der Regel 2–4 Monate. Nach erfolgreicher Prüfung erhalten Sie Ihren Gutschein per E-Mail.'
    },
    {
      question: 'Welche Fahrzeuge sind berechtigt?',
      answer: 'Alle rein elektrischen Fahrzeuge (BEV) sind berechtigt. Hybridfahrzeuge sind nicht förderfähig.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-muted-foreground">
            Alles, was Sie zum Gutschein und zur THG-Quote wissen müssen
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className="bg-card rounded-lg shadow-card overflow-hidden transition-smooth"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-muted/50 transition-smooth"
              >
                <span className="font-heading font-semibold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  color="var(--color-primary)"
                  className="flex-shrink-0"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 text-muted-foreground animate-fade-in">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-primary/10 border border-primary/20 rounded-lg p-6 text-center">
          <Icon name="HelpCircle" size={32} color="var(--color-primary)" className="mx-auto mb-4" />
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Weitere Fragen?
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            Unser Support-Team hilft Ihnen gerne weiter
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:+4915223152476"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth"
            >
              <Icon name="Phone" size={18} />
              +49 152 231 524 76
            </a>
            <a
              href="mailto:oliver.wagner@gridbalance.de"
              className="inline-flex items-center gap-2 px-4 py-2 bg-card text-foreground border border-border rounded-lg hover:bg-muted transition-smooth"
            >
              <Icon name="Mail" size={18} />
              oliver.wagner@gridbalance.de
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;